import type { SvgIconComponent } from "@mui/icons-material";
import { Box, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import type { ReactNode } from "react";
import { Link as RouterLink } from "react-router";
import BadgeDetached from "@entrilia/shared/components/BadgeDetached";

interface Props {
  id?: string;
  title: string;
  Icon?: SvgIconComponent;
  EndIcon?: SvgIconComponent;
  href: string;
  active?: boolean;
  subItem?: boolean;
  badgeCount?: number;
  chip?: ReactNode;
}

const MenuLinkItem = ({ id, href, title, Icon, EndIcon, active, subItem, badgeCount, chip }: Props) => {
  const textColor = active ? "primary.main" : subItem ? "text.secondary" : "text.primary";

  return (
    <MenuItem
      id={id}
      component={RouterLink}
      to={href}
      sx={(t) => ({ py: 1, px: 2, bgcolor: active ? t.palette.action.selected : undefined })}
    >
      {Icon && (
        <ListItemIcon>
          <Icon sx={{ color: active ? textColor : undefined }} />
        </ListItemIcon>
      )}
      <ListItemText slotProps={{ primary: { sx: { color: textColor } } }}>{title}</ListItemText>
      {chip}
      {EndIcon && (
        <ListItemIcon sx={{ justifyContent: "flex-end" }}>
          <EndIcon sx={{ color: active ? textColor : undefined }} />
        </ListItemIcon>
      )}
      {badgeCount !== undefined && (
        <Box>
          <BadgeDetached badgeContent={badgeCount} color="primary" />
        </Box>
      )}
    </MenuItem>
  );
};

export default MenuLinkItem;
